import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email:'admin@teknulugy.com', password:'' });
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(form.email, form.password); navigate('/'); }
    catch(err) { toast.error(err.response?.data?.message||'Login failed'); }
    finally { setLoading(false); }
  };
  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:32}}>
          <img src="/logo.jpg" alt="Teknulugy" style={{width:52,height:52,borderRadius:12,objectFit:'cover',boxShadow:'0 2px 8px rgba(0,179,104,0.3)'}}/>
          <div><div style={{fontFamily:'Syne,sans-serif',fontSize:18,fontWeight:700}}>TEKNULUGY</div>
          <div style={{fontSize:11,color:'var(--muted)'}}>IT Services CRM</div></div>
        </div>
        <div style={{marginBottom:24}}>
          <div style={{fontFamily:'Syne,sans-serif',fontSize:20,fontWeight:600,marginBottom:4}}>Welcome back</div>
          <div style={{fontSize:13,color:'var(--muted)'}}>Sign in to your account</div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{marginBottom:14}}>
            <label className="form-label">Email</label>
            <input className="form-input" type="email" value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))} required/>
          </div>
          <div className="form-group" style={{marginBottom:24}}>
            <label className="form-label">Password</label>
            <input className="form-input" type="password" value={form.password} onChange={e=>setForm(p=>({...p,password:e.target.value}))} placeholder="••••••••" required/>
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading} style={{width:'100%',justifyContent:'center',padding:'11px 0',fontSize:14}}>
            {loading?'Signing in…':'Sign In'}
          </button>
        </form>
        <div style={{marginTop:20,padding:'12px 16px',background:'var(--surface2)',borderRadius:8,fontSize:12,color:'var(--muted)'}}>
          Default: <strong style={{color:'var(--text)'}}>admin@teknulugy.com</strong> / <strong style={{color:'var(--text)'}}>Admin@123</strong>
        </div>
      </div>
    </div>
  );
}
